import { Action } from 'redux';
import { connect } from 'react-redux';
import { dispatchAsync } from 'react-redux-dispatch-async';
import { getConnectedUser } from 'authContext/usecases/Auth.selectors';
import { ProductCardDumb } from './ProductCard.dumb';
import { AppState } from '../../../configuration/app.states';
import { Product } from '../../../../generalContext/domain/entities/Product';
import {
  deleteCartProductRequest,
  deleteWishProductRequest,
  saveCartProductRequest,
  saveWishProductRequest,
} from '../../../../generalContext/usecases/General.actions';
import { getStateCart, getStateWishProducts } from '../../../../generalContext/usecases/General.selectors';

const mapState = (state: AppState) => ({
  stateWishProducts: getStateWishProducts(state),
  stateCart: getStateCart(state),
  stateConnectedUser: getConnectedUser(state),
});

const mapDispatch = (dispatch: (a: Action) => void) => ({
  saveWishProductAsync: (product: Product) => dispatchAsync(dispatch, saveWishProductRequest(product)),
  deleteWishProductAsync: (Art_Ean13: string) => dispatchAsync(dispatch, deleteWishProductRequest(Art_Ean13)),
  saveCartProductAsync: (product: Product) => dispatchAsync(dispatch, saveCartProductRequest(product)),
  deleteCartProductAsync: (Art_Ean13: string) => dispatchAsync(dispatch, deleteCartProductRequest(Art_Ean13)),
});

export const ProductCardSmart = connect(mapState, mapDispatch)(ProductCardDumb);
